<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Notatki'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="note-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="note-list-filters">
    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="note-list-filter note-list-filter-long"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="note-list-filter note-list-filter-long"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <mat-form-field class="note-list-filter note-list-filter-short">
      <mat-label>Partner poza strukturą</mat-label>
      <input matInput name="contains$partnerOutsideStructure" [(ngModel)]="initialFilters.contains$partnerOutsideStructure">
    </mat-form-field>

    <app-datepicker
      class="note-list-filter"
      label="Data od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$meetingDateTime" name="gte$meetingDateTime"
    ></app-datepicker>

    <app-datepicker
      class="note-list-filter"
      label="Data do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$meetingDateTime" name="lte$meetingDateTime"
    ></app-datepicker>

    <mat-form-field appearance="standard" class="note-list-filter">
      <mat-label>Spotkanie odwołane</mat-label>
      <mat-select [(ngModel)]="initialFilters.tookPlace" name="tookPlace">
        <mat-option [value]="undefined">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict class="note-list-filter"
      [multiple]="false" [dictType]="'type_of_meeting'"
      [label]="'Rodzaj'"
      [(ngModel)]="initialFilters.typeOfMeeting" name="typeOfMeeting"
    ></app-dict>

<!--    <app-dict-regionals class="note-list-filter"-->
<!--      [noneEntry]="true" [multiple]="true"-->
<!--      [label]="'Regionalny'"-->
<!--      [(ngModel)]="initialFilters.regional" name="regional"-->
<!--    ></app-dict-regionals>-->

    <mat-form-field class="note-list-filter note-list-filter-short">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="Jan Kowalski" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>
  </form>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
    <div>
      <button [disabled]="!(userPermissions | async)?.note.limited_read" (click)="addNote()" mat-stroked-button color="primary">
        <mat-icon>add</mat-icon> <span> Dodaj notatkę</span>
      </button>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="(userPermissions | async).note.limited_read" (click)="downloadReport()" [disabled]="!(userPermissions | async).note.limited_read"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span>
      </button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="notes" matSort (matSortChange)="sortChanged($event)">

    <ng-container matColumnDef="typeOfMeeting">
      <th mat-header-cell *matHeaderCellDef> Rodzaj </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!disableLinks">
          <a class="default-link" [routerLink]="['/notatki/szczegoly', element.uuid]">
            {{ element?.typeOfMeeting?.name}}
          </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="meetingDateTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="meetingDateTime"> Data </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/notatki/szczegoly', element.uuid]">
          {{ element.meetingDateTime | date: 'yyyy-MM-dd HH:mm':'UTC' }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="meetingEndDate">
      <th mat-header-cell *matHeaderCellDef> Data do </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element?.meetingEndDate">{{element?.meetingEndDate | date: 'yyyy-MM-dd'}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerOrOfwca">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          Partner: <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          OFWCA: <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
        </ng-container>
        <ng-container *ngIf="element.partnerOutsideStructure">
          Partner poza strukturą: {{element.partnerOutsideStructure}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="regional">
      <th mat-header-cell *matHeaderCellDef> Regionalny majątek </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!disableLinks">
          <a *ngIf="element.regional">{{element.regional.fullName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="tookPlace">
      <th mat-header-cell *matHeaderCellDef> Spotkanie odwołane </th>
      <td mat-cell *matCellDef="let element">
        {{element.tookPlace ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName +' '+ element.createdBy.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!((userPermissions | async)?.note?.admin_root || element.createdBy?.uuid === profile?.userId)" mat-menu-item (click)="deleteNote(element)">
            Usuń
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
